import { Row } from "react-table";

export const GetSelectedDataFromSelectedFlatRows = <
  TData extends Record<string, unknown>
>(
  selectedFlatRows?: Row<TData>[]
) => selectedFlatRows?.map((row) => row.original) ?? [];
